import api from "../../api.js";
import web from "../../index.js";

export default class PageTeamCreate
{
    createTeam(button)
    {
        const name = document.getElementById("team-name").value;
        const description = document.getElementById("team-description").value;
        const registerNamespace = true;

        web.buttons.startSavingAnimButton(button);
        api.post(
            "teams/create",
            {
                "name": name,
                "description": description,
                "registerNamespace": registerNamespace
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button);
                window.location.href = "/team/" + res.data._id + "/settings";
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button, true, true);
            });
    }
}
